import { Field, Form, useFormikContext } from 'formik';
import React, { FunctionComponent, useEffect } from 'react';
import styled from 'styled-components';

import { FormValues } from './PlaidAchRelationship';
import { Button, FormGroup, Text, TextboxField } from '@tradingblock/components';

const StyledPlaidAchRelationshipForm = styled.div`
  button {
    width: 100%;
    margin-bottom: 1rem;
  }
`;

interface PlaidAchRelationshipFormProps {
  accountName: string | null;
  errorSubmittingFundingMethodRequest: boolean;
};

const PlaidAchRelationshipForm: FunctionComponent<PlaidAchRelationshipFormProps> = ({
  accountName,
  errorSubmittingFundingMethodRequest
}) => {
  const { setValues, values } = useFormikContext<FormValues>();

  useEffect(() => {
    setValues({ ...values, accountNickname: accountName || '' });
  }, [accountName]);

  return (
    <StyledPlaidAchRelationshipForm>
      <Form translate={undefined}>
        <FormGroup>
          <Field
            component={TextboxField}
            id="accountNickname"
            placeholder={<Text id="fundYourAccountComponent.nicknameForBankAccount" />}
          />
        </FormGroup>

        <p><Text id="fundYourAccountComponent.newFundingMethodRequest" /></p>

        {errorSubmittingFundingMethodRequest && <p className="error"><Text id="fundYourAccountComponent.issueSubmittingFundingMethodRequest" type="error" /></p>}

        <Button
          className="btn-primary"
          type="submit"
        >
          <Text id="btns.submitFundingMethodRequest" />
        </Button>
      </Form>
    </StyledPlaidAchRelationshipForm>
  );
}

export default PlaidAchRelationshipForm;
